import { jQuery as $ } from 'mk/jQuery';
import { photoblog_api_v1_flagged_counts_url } from 'mk/urls/functions';
import * as xhr from 'mk/xhr/client';

export function init() {
    xhr
        .get(photoblog_api_v1_flagged_counts_url())
        .then(
            (response) => {
                if (response.body.flagged_count) {
                    $('.js-flagged-count')
                        .append(`<div class="notif admin">${response.body.flagged_count}</div>`);
                }
                if (response.body.flagged_groups_count) {
                    $('.js-flagged-groups-count')
                        .append(`<div class="notif admin">${response.body.flagged_groups_count}</div>`);
                }
            },
        );
}
